import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox viewBox="0 12 64 40" {...props}>
    <path d="M32 51.5L0 19.5L6.5 13L32 38.5L57.5 13L64 19.5L32 51.5Z" />
  </IconBox>
);
